export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'SYR-SY',
        name: 'Syriac',
        normal: '\u070f1234567890-=܆ܔܨܖܩܦܜܥܗܞܚܓܕܫܣܝܒܠܐܬܢܡܟܛ][ܤܪܧ܀.ܘܙ܇',
        shift: { 0: '̮!̥̊݉♰♱܊»)(«+:ܑܱܴܷܻܾܰܳܶܺܽ݀݁̈̄̇̃݊ـ̤̱̣̰ܸܼܹ݂ܲܵܿ،؛؟' },
        alt: { 0: 'ّ܁܂܃܄܅܈܉܋܌܍┌┐', 14: 'ًٌَُ̭ٓٔ݇݃݅', 26: 'ٍِٖءٰٕ݈݄݆', 38: 'ْ', 40: '\u200d\u200c\u200e\u200f' }
    })
}
